/** `<meta name>` the deal layout sets so client nav metrics inherit caller_kind. */
export const DEAL_PACKAGE_ROUTE_CALLER_KIND_META_NAME =
  'clai-deal-package-route-caller-kind';

/** Request header: proxy stamped when a deal-package document GET enters the app. */
export const DEAL_PACKAGE_ROUTE_INSTRUMENT_HEADER = 'x-clai-deal-package-route';

/** Request header: epoch ms when proxy began handling the document request. */
export const DEAL_PACKAGE_ROUTE_REQ_START_MS_HEADER =
  'x-clai-deal-package-req-start-ms';

/** Request header: `1` when the URL carried `submissionId` (value never forwarded). */
export const DEAL_PACKAGE_ROUTE_HAS_SUBMISSION_ID_HEADER =
  'x-clai-deal-package-has-submission-id';

/** Root-span / span attribute keys (EAP Spans dataset). */
export const DEAL_PACKAGE_ROUTE_ATTR = {
  HAS_SUBMISSION_ID: 'deal_package.has_submission_id',
  CALLER_KIND: 'deal_package.caller_kind',
  LAYOUT_COMPLETE_MS: 'deal_package.layout_complete_ms',
  RESPONSE_COMPLETE_MS: 'deal_package.response_complete_ms',
  PROXY_MS: 'deal_package.proxy_ms',
} as const;

export type DealPackageRouteCallerKind =
  | 'org_member'
  | 'outside_signer'
  | 'unknown';

/** Sentry `tracesSampler` / transaction tag for discoverability. */
export const DEAL_PACKAGE_ROUTE_TRACE_TAG = 'deal_package.document_route';

/** `ssr.stage` span prefix for nested layout work on this route. */
export const DEAL_PACKAGE_ROUTE_STAGE_OP = 'deal_package.stage';

/** Edge middleware span for instrumented document GETs. */
export const DEAL_PACKAGE_ROUTE_PROXY_SPAN = 'deal-package-route.proxy';

/** Client distribution metrics (unsampled — see signing boot metrics). */
export const DEAL_PACKAGE_ROUTE_NAV_METRIC_NAMES = {
  queue_ms: 'deal_package.nav.queue_ms',
  ttfb_ms: 'deal_package.nav.ttfb_ms',
  download_ms: 'deal_package.nav.download_ms',
  dom_interactive_ms: 'deal_package.nav.dom_interactive_ms',
  load_event_ms: 'deal_package.nav.load_event_ms',
  proxy_server_timing_ms: 'deal_package.nav.proxy_server_timing_ms',
} as const;

/** `Server-Timing` metric name emitted by `proxy.ts`. */
export const DEAL_PACKAGE_ROUTE_PROXY_SERVER_TIMING = 'clai-proxy';
